import React from "react";

export default function ProductCard({ image, name, subtitle, tags, price }) {
  return (
    <article className="card productCard">
      <div className="productThumb" style={{ backgroundImage: `url(${image})` }} />
      <div className="productBody">
        <div className="productTop">
          <h3 className="productName">{name}</h3>
          <div className="pill">{price}</div>
        </div>
        <div className="small">{subtitle}</div>
        <div className="tagRow">
          {tags.map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
        </div>
      </div>
    </article>
  );
}
